// Utility functions for DOM event checking - these are pure functions that don't manipulate DOM
export function isTargetInside(event: Event, selector: string): boolean {
  const target = event.target as Element;
  return !!target?.closest(selector);
}

export function targetHasClass(event: Event, className: string): boolean {
  const target = event.target as Element;
  return target?.classList?.contains(className) || false;
}

// Component coordination utilities - these help components coordinate without direct DOM manipulation
export interface EventCoordinates {
  pageX: number;
  pageY: number;
  offsetX: number;
  clientRect: DOMRect;
}
